import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const notificationUpdateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_EVENT_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_EVENT_UPDATE_SUCCESS:
      if (!action.payload) {
        return {...state};
      }

      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_EVENT_UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_EVENT_UPDATE_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
